import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] rounded-t-[40px] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Company Info & Newsletter */}
          <div className="md:col-span-1">
            <img 
              src="https://public.readdy.ai/ai/img_res/89f2e3be-f2ad-453e-92a0-c2253a51973a.png" 
              alt="Valve Sales Supply" 
              className="h-12 w-auto mb-4 filter brightness-0 invert"
            />
            <p className="text-gray-400 mb-8 text-lg">Professional industrial equipment buyers</p>
            <div className="space-y-4">
              <input
                type="email"
                placeholder="Your email address"
                className="w-full bg-transparent border-b border-gray-600 pb-2 text-white placeholder-gray-400 focus:border-white outline-none"
              />
              <button className="bg-white text-[#1B3A5F] px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors duration-300 flex items-center">
                GET UPDATES
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#6B7280] uppercase text-sm font-semibold mb-6 tracking-wider">QUICK LINKS</h4>
            <ul className="space-y-4">
              {[
                { path: '/what-we-buy', label: 'What We Buy' },
                { path: '/how-it-works', label: 'How It Works' },
                { path: '/service-areas', label: 'Service Areas' },
                { path: '/about', label: 'About Us' },
                { path: '/contact', label: 'Contact' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-white hover:underline transition-all duration-300"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Equipment Categories */}
          <div>
            <h4 className="text-[#6B7280] uppercase text-sm font-semibold mb-6 tracking-wider">EQUIPMENT</h4>
            <ul className="space-y-4">
              {['Valves', 'Meters', 'Controls', 'Instrumentation', 'All Categories'].map((item) => (
                <li key={item}>
                  <Link
                    to="/what-we-buy"
                    className="text-white hover:underline transition-all duration-300"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#6B7280] uppercase text-sm font-semibold mb-6 tracking-wider">CONTACT US</h4>
            <div className="space-y-4">
              <a
                href="tel:214-854-5638"
                className="text-white text-2xl font-bold block hover:text-gray-300 transition-colors"
              >
                (214) 854-5638
              </a>
              <a
                href="mailto:valvesalessupply@gmail.com"
                className="text-white hover:underline block"
              >
                valvesalessupply@gmail.com
              </a>
              <div className="mt-8">
                <h5 className="text-[#6B7280] uppercase text-sm font-semibold mb-2 tracking-wider">OFFICE HOURS</h5>
                <p className="text-white">Mon-Fri: 7AM-6PM CST</p>
                <p className="text-white">Sat: 8AM-2PM CST</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#6B7280] mt-16 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="flex space-x-4 mb-4 md:mb-0">
            <a href="#" className="text-gray-400 hover:text-white transition-colors">
              <i className="ri-linkedin-line text-xl"></i>
            </a>
            <a href="https://www.facebook.com/valvesalessupply" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors">
              <i className="ri-facebook-line text-xl"></i>
            </a>
          </div>
          <p className="text-gray-400 text-sm text-center">
            © 2025 Valve Sales Supply. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">Privacy Policy</Link>
            <span className="text-gray-600">|</span>
            <Link to="#" className="text-gray-400 hover:text-white text-sm transition-colors">Terms of Service</Link>
          </div>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-gray-400 text-sm transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
